// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container matching Dashboard gradient */
.elder-request-container {
    min-height: 100vh;
    background: linear-gradient(135deg, #f8fafc 0%, #eef2f6 100%);
    font-family: inherit;
    display: flex;
    flex-direction: column;
}

.center-content {
    justify-content: center;
    align-items: center;
}

.loading-text {
    margin-top: 1.5rem;
    font-size: 1.2rem;
    color: #475569;
    font-weight: 500;
}

/* === HEADER === */
.groups-header {
    margin-bottom: 1rem;
}

.elder-back-btn {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background: white;
    border: 1px solid #cbd5e1;
    padding: 0.6rem 1rem;
    border-radius: 10px;
    font-size: 1rem;
    font-weight: 600;
    color: #334155;
    cursor: pointer;
    transition: all 0.2s;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.elder-back-btn:hover {
    background: #f1f5f9;
    border-color: #94a3b8;
    color: #1e293b;
}

.page-title {
    margin: 0;
    font-size: 1.5rem;
    color: #1e293b;
    font-weight: 800;
}

/* === MAIN CONTENT === */
.request-main-content {
    padding: 0 2rem 4rem 2rem;
    max-width: 900px;
    margin: 0 auto;
    width: 100%;
    box-sizing: border-box;
}

.page-description {
    font-size: 1.15rem;
    color: #475569;
    margin-bottom: 2.5rem;
    line-height: 1.5;
    background: white;
    padding: 1.25rem;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
}

.elder-section {
    margin-bottom: 1rem;
}

.elder-section-title {
    font-size: 1.4rem;
    font-weight: 800;
    margin-bottom: 1.25rem;
    padding-left: 0.25rem;
}

.elder-divider {
    height: 1px;
    background: #cbd5e1;
    margin: 2.5rem 0;
}

/* === LIST STYLES (STRIP CARDS) === */
.elder-list-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.elder-list-card {
    background: white;
    border-radius: 16px;
    padding: 1.25rem 1.5rem;
    border: 1px solid rgba(226, 232, 240, 0.8);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
}

/* Inside the strip card */
.list-card-left {
    display: flex;
    align-items: center;
    gap: 1.25rem;
    flex: 1 1;
}

.list-card-info {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
}

.list-card-right {
    flex-shrink: 0;
}

/* Icons */
.icon-wrapper {
    height: 54px;
    width: 54px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.blue-icon {
    background: #eff6ff;
    color: #3b82f6;
}

.green-icon {
    background: #f0fdf4;
    color: #10b981;
}

/* Typography */
.elder-card-title {
    margin: 0;
    font-size: 1.2rem;
    color: #1e293b;
    font-weight: 700;
}

.amount-text {
    font-size: 1.3rem;
    display: block;
    margin-top: 0.2rem;
}

.font-bold {
    font-weight: 800;
}

.text-green {
    color: #059669;
}

.text-blue {
    color: #2563eb;
}

/* === BUTTONS === */
.elder-btn-primary {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    background: #2563eb;
    /* Blue default */
    color: white;
    border: none;
    padding: 0.85rem 1.5rem;
    border-radius: 12px;
    font-size: 1rem;
    font-weight: 700;
    cursor: pointer;
    transition: background 0.2s;
    white-space: nowrap;
}

.elder-btn-primary:hover:not(:disabled) {
    background: #1d4ed8;
}

.bg-green-btn {
    background: #10b981;
}

.bg-green-btn:hover:not(:disabled) {
    background: #059669;
}

.elder-btn-primary:disabled {
    background: #94a3b8;
    cursor: not-allowed;
}

.elder-btn-success {
    background: #f0fdf4;
    color: #059669;
    border: 2px solid #10b981;
    padding: 0.75rem 1.25rem;
    border-radius: 12px;
    font-size: 1rem;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    cursor: default;
    white-space: nowrap;
}

.elder-empty-card {
    background: white;
    border-radius: 16px;
    padding: 2.5rem;
    text-align: center;
    font-size: 1.15rem;
    color: #64748b;
    border: 2px dashed #cbd5e1;
}

/* === RESPONSIVE FOR MOBILE === */
@media (max-width: 768px) {
    .groups-header {
        padding: 1.25rem;
    }

    .request-main-content {
        padding: 0 1.25rem 3rem 1.25rem;
    }

    .page-description {
        font-size: 1.05rem;
        padding: 1rem;
    }

    .elder-list-card {
        flex-direction: column;
        align-items: flex-start;
        padding: 1.25rem;
        gap: 1.25rem;
    }

    .list-card-left {
        width: 100%;
    }

    .list-card-right {
        width: 100%;
        border-top: 1px solid #f1f5f9;
        padding-top: 1rem;
    }

    .elder-btn-primary,
    .elder-btn-success {
        width: 100%;
        padding: 1rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/member/RaiseRequest.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;IACI,iBAAiB;IACjB,6DAA6D;IAC7D,oBAAoB;IACpB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA,mBAAmB;AACnB;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA,yBAAyB;AACzB;IACI,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,sCAAsC;AACtC;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;IACvB,0CAA0C;IAC1C,8CAA8C;IAC9C,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,SAAO;AACX;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA,UAAU;AACV;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,eAAe;AACf;IACI,SAAS;IACT,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,wBAAwB;IACxB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,0BAA0B;AAC9B;;AAEA,kCAAkC;AAClC;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,kBAAkB;QAClB,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,6BAA6B;QAC7B,iBAAiB;IACrB;;IAEA;;QAEI,WAAW;QACX,aAAa;IACjB;AACJ","sourcesContent":["/* Container matching Dashboard gradient */\n.elder-request-container {\n    min-height: 100vh;\n    background: linear-gradient(135deg, #f8fafc 0%, #eef2f6 100%);\n    font-family: inherit;\n    display: flex;\n    flex-direction: column;\n}\n\n.center-content {\n    justify-content: center;\n    align-items: center;\n}\n\n.loading-text {\n    margin-top: 1.5rem;\n    font-size: 1.2rem;\n    color: #475569;\n    font-weight: 500;\n}\n\n/* === HEADER === */\n.groups-header {\n    margin-bottom: 1rem;\n}\n\n.elder-back-btn {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    background: white;\n    border: 1px solid #cbd5e1;\n    padding: 0.6rem 1rem;\n    border-radius: 10px;\n    font-size: 1rem;\n    font-weight: 600;\n    color: #334155;\n    cursor: pointer;\n    transition: all 0.2s;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.elder-back-btn:hover {\n    background: #f1f5f9;\n    border-color: #94a3b8;\n    color: #1e293b;\n}\n\n.page-title {\n    margin: 0;\n    font-size: 1.5rem;\n    color: #1e293b;\n    font-weight: 800;\n}\n\n/* === MAIN CONTENT === */\n.request-main-content {\n    padding: 0 2rem 4rem 2rem;\n    max-width: 900px;\n    margin: 0 auto;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n.page-description {\n    font-size: 1.15rem;\n    color: #475569;\n    margin-bottom: 2.5rem;\n    line-height: 1.5;\n    background: white;\n    padding: 1.25rem;\n    border-radius: 12px;\n    border: 1px solid #e2e8f0;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);\n}\n\n.elder-section {\n    margin-bottom: 1rem;\n}\n\n.elder-section-title {\n    font-size: 1.4rem;\n    font-weight: 800;\n    margin-bottom: 1.25rem;\n    padding-left: 0.25rem;\n}\n\n.elder-divider {\n    height: 1px;\n    background: #cbd5e1;\n    margin: 2.5rem 0;\n}\n\n/* === LIST STYLES (STRIP CARDS) === */\n.elder-list-container {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.elder-list-card {\n    background: white;\n    border-radius: 16px;\n    padding: 1.25rem 1.5rem;\n    border: 1px solid rgba(226, 232, 240, 0.8);\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 1rem;\n}\n\n/* Inside the strip card */\n.list-card-left {\n    display: flex;\n    align-items: center;\n    gap: 1.25rem;\n    flex: 1;\n}\n\n.list-card-info {\n    display: flex;\n    flex-direction: column;\n    gap: 0.35rem;\n}\n\n.list-card-right {\n    flex-shrink: 0;\n}\n\n/* Icons */\n.icon-wrapper {\n    height: 54px;\n    width: 54px;\n    border-radius: 14px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.blue-icon {\n    background: #eff6ff;\n    color: #3b82f6;\n}\n\n.green-icon {\n    background: #f0fdf4;\n    color: #10b981;\n}\n\n/* Typography */\n.elder-card-title {\n    margin: 0;\n    font-size: 1.2rem;\n    color: #1e293b;\n    font-weight: 700;\n}\n\n.amount-text {\n    font-size: 1.3rem;\n    display: block;\n    margin-top: 0.2rem;\n}\n\n.font-bold {\n    font-weight: 800;\n}\n\n.text-green {\n    color: #059669;\n}\n\n.text-blue {\n    color: #2563eb;\n}\n\n/* === BUTTONS === */\n.elder-btn-primary {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n    background: #2563eb;\n    /* Blue default */\n    color: white;\n    border: none;\n    padding: 0.85rem 1.5rem;\n    border-radius: 12px;\n    font-size: 1rem;\n    font-weight: 700;\n    cursor: pointer;\n    transition: background 0.2s;\n    white-space: nowrap;\n}\n\n.elder-btn-primary:hover:not(:disabled) {\n    background: #1d4ed8;\n}\n\n.bg-green-btn {\n    background: #10b981;\n}\n\n.bg-green-btn:hover:not(:disabled) {\n    background: #059669;\n}\n\n.elder-btn-primary:disabled {\n    background: #94a3b8;\n    cursor: not-allowed;\n}\n\n.elder-btn-success {\n    background: #f0fdf4;\n    color: #059669;\n    border: 2px solid #10b981;\n    padding: 0.75rem 1.25rem;\n    border-radius: 12px;\n    font-size: 1rem;\n    font-weight: 700;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n    cursor: default;\n    white-space: nowrap;\n}\n\n.elder-empty-card {\n    background: white;\n    border-radius: 16px;\n    padding: 2.5rem;\n    text-align: center;\n    font-size: 1.15rem;\n    color: #64748b;\n    border: 2px dashed #cbd5e1;\n}\n\n/* === RESPONSIVE FOR MOBILE === */\n@media (max-width: 768px) {\n    .groups-header {\n        padding: 1.25rem;\n    }\n\n    .request-main-content {\n        padding: 0 1.25rem 3rem 1.25rem;\n    }\n\n    .page-description {\n        font-size: 1.05rem;\n        padding: 1rem;\n    }\n\n    .elder-list-card {\n        flex-direction: column;\n        align-items: flex-start;\n        padding: 1.25rem;\n        gap: 1.25rem;\n    }\n\n    .list-card-left {\n        width: 100%;\n    }\n\n    .list-card-right {\n        width: 100%;\n        border-top: 1px solid #f1f5f9;\n        padding-top: 1rem;\n    }\n\n    .elder-btn-primary,\n    .elder-btn-success {\n        width: 100%;\n        padding: 1rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
